import { render, staticRenderFns } from "./graph1wave.vue?vue&type=template&id=e4c423e4"
import script from "./graph1wave.vue?vue&type=script&lang=js"
export * from "./graph1wave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports